var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',_vm._b({attrs:{"name":_vm.iconName}},'Icon',Object.assign({}, _vm.iconProps),false))}
var staticRenderFns = []

export { render, staticRenderFns }